import { Button, Modal } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';

export const ConfirmationModal = ({
  showModal,
  handleClose,
  handleConfirm,
  templateId,
  actionType, // 'delete' or 'verify'
  actionModel,
  smsTemplateCount,
  title
}) => {
  let modalTitle = '';
  let modalBody = '';
  let confirmButtonLabel = '';
  let confirmButtonVariant = 'danger';

  // Set dynamic content based on the actionType
  if (actionType === 'delete') {
    modalTitle = 'Confirm Deletion';
    modalBody =
      actionModel === 'group_template'
        ? `This category includes <strong>${smsTemplateCount} campaign texts</strong>. Deleting it will remove all associated texts. Are you sure? <strong>This action cannot be undone.</strong>`
        : `Are you sure you want to delete this ${title}? <strong>This action cannot be undone.</strong>`;
    confirmButtonLabel = 'Delete';
  } else if (actionType === 'verify') {
    modalTitle = 'Confirm Verification';
    modalBody =
      'Are you sure you want to verify this template? This action cannot be undone.';
    confirmButtonLabel = 'Verify';
    confirmButtonVariant = 'primary'; // Optional: You can change the variant based on action type
  }

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p dangerouslySetInnerHTML={{ __html: modalBody }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant={confirmButtonVariant}
          onClick={() => handleConfirm(templateId)} // Pass the templateId for confirmation
        >
          {confirmButtonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  templateId: PropTypes.number,
  actionType: PropTypes.oneOf(['delete', 'verify']).isRequired, // actionType can either be 'delete' or 'verify'
  actionModel: PropTypes.string.isRequired,
  smsTemplateCount: PropTypes.number.isRequired,
  title: PropTypes.string
};
